/* eslint-disable react/prop-types */
import React from 'react';

import {connect} from 'react-redux';

import * as setupActions from '@/actions/setupActions';
import * as APPDATA from '@/constants/pcConstAppData';

import './AutoProfileHelp.scss';

@connect((store) => ({
  modeHelp: store.setupStore.modeHelp,
}))
class AutoProfileHelpContent extends React.PureComponent {
  onClick = (e) => {
    const {dispatch} = this.props;
    switch (e.currentTarget.id) {
      case APPDATA.BACK_TO_TOP:
        dispatch(setupActions.updateMessageAutoProfileHelpParam(APPDATA.HOME_HELP));
        break;
      default:
        break;
    }
  };

  render() {
    const {content} = this.props;
    return (
      <>
        {content}
        <div className="backToTop">
          <button
            type="button"
            id={APPDATA.BACK_TO_TOP}
            className="backToTopButton"
            onClick={this.onClick}
          >
            {APPDATA.BACK_TO_TOP}
          </button>
        </div>
      </>
    );
  }
}
export default AutoProfileHelpContent;
